import { createFileRoute } from "@tanstack/react-router";
import AdminLoginLink from "@/pages/AdminLoginLink";

export const Route = createFileRoute("/admin/login-link/")({
  component: AdminLoginLink,
});
